import { render, staticRenderFns } from "./ErrorLegend.vue?vue&type=template&id=24fdf5a4&scoped=true&"
import script from "./ErrorLegend.vue?vue&type=script&lang=js&"
export * from "./ErrorLegend.vue?vue&type=script&lang=js&"
import style0 from "./ErrorLegend.vue?vue&type=style&index=0&id=24fdf5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fdf5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fdf5a4')) {
      api.createRecord('24fdf5a4', component.options)
    } else {
      api.reload('24fdf5a4', component.options)
    }
    module.hot.accept("./ErrorLegend.vue?vue&type=template&id=24fdf5a4&scoped=true&", function () {
      api.rerender('24fdf5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/ErrorLegend.vue"
export default component.exports